(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbToDoListContextMenu', ToDoListContextMenuDirective)
		.controller('smbToDoListContextMenuController', [
			'smbToolbarService',
			'smbToDoListDataStore',
			ToDoListContextMenuController
		]);

	var templateUrl = require('./todolistContextMenu.template.html');
	function ToDoListContextMenuDirective() {
		return {
			restrict: 'E',
			controller: 'smbToDoListContextMenuController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: { }
		};
	}

	function ToDoListContextMenuController(smbToolbarService, smbToDoListDataStore) {
		var vm = this;
		vm.smbToolbarService = smbToolbarService;
		vm.todolistDS = smbToDoListDataStore;

		vm.dateAscending = false;
		vm.dateDescending = true;
		vm.typeAscending = false;
		vm.typeDescending = false;
		vm.statusAscending = false;
		vm.statusDescending = false;

		vm.sortByDate = sortByDate;
		vm.sortByType = sortByType;
		vm.sortByStatus = sortByStatus;
		vm.dateActive = true;
		vm.typeActive = false;
		vm.statusActive = false;

		var ASCENDING = true;
		var DESCENDING = false;

		function sortByDate() {
			if (vm.dateActive) {
				vm.dateAscending = !vm.dateAscending;
				vm.dateDescending = !vm.dateDescending;
			}
			else {
				vm.dateActive = true;
				vm.typeActive = false;
				vm.statusActive = false;
				vm.dateAscending = true;
				vm.dateDescending = false;
			}
			if (vm.dateAscending) {
				vm.todolistDS.sortByDate(ASCENDING);
			}
			else {
				vm.todolistDS.sortByDate(DESCENDING);
			}
		}

		function sortByType() {
			if (vm.typeActive) {
				vm.typeAscending = !vm.typeAscending;
				vm.typeDescending = !vm.typeDescending;
			}
			else {
				vm.dateActive = false;
				vm.typeActive = true;
				vm.statusActive = false;
				vm.typeAscending = true;
				vm.typeDescending = false;
			}
			if (vm.typeAscending) {
				vm.todolistDS.sortByType(ASCENDING);
			}
			else {
				vm.todolistDS.sortByType(DESCENDING);
			}
		}

		function sortByStatus() {
			if (vm.statusActive) {
				vm.statusAscending = !vm.statusAscending;
				vm.statusDescending = !vm.statusDescending;
			}
			else {
				vm.dateActive = false;
				vm.typeActive = false;
				vm.statusActive = true;
				vm.statusAscending = true;
				vm.statusDescending = false;
			}
			if (vm.statusAscending) {
				vm.todolistDS.sortByStatus(ASCENDING);
			}
			else {
				vm.todolistDS.sortByStatus(DESCENDING);
			}
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/todolistContextMenu/todolistContextMenu.js
// module id = 98
// module chunks = 1